var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var jwtDecode = require('jwt-decode')
var _ = require('lodash')
var BaseCollection = require('src/common/base-collection')

var Users = function () {
  var currentUser

  // init
  var User = BaseModel.extend({
    urlRoot: Config.api.host + '/users',
    idAttribute: '_id',
    defaults: {
      role: ''
    },
    validation: {
    },
    resetPassword: function (opts) {
      // https://gist.github.com/sap1ens/4692429
      var url = this.url() + '/password',
        options = {
          url: url,
          type: 'POST'
        }

      // add any additional options, e.g. a "success" callback or data
      options = _.extend(options, opts)
      //
      return (this.sync || Backbone.sync).call(this, null, this, options)
    },
    hasRole: function (roles) {
      if (!roles) return true
      if (!Array.isArray(roles)) roles = [roles]

      if (roles.length <= 0) return true
      var myRole = this.get('role')

      if (_.indexOf(roles, myRole) > -1) {
        return true
      }

      return false
    }
  })

  var UsersCollection = BaseCollection.extend({
    url: Config.api.host + '/users',
    model: User
    // parse: function (data) {
    //   if (!data.data) return data
    //   return data.data
    // }
  })

  // //
  var API = {
    getUserEntities: function (options) {
      var fetchParams = { reset: true }
      if (options) { if (options.query) fetchParams.data = options.query }

      var users = new UsersCollection([], options)
      users.fetch(fetchParams)
      return users
    },
    getUserEntity: function (id, options) {
      var user = new User({_id: id})

      user.fetch(options)
      return user
    },
    newUserEntity: function () {
      return new User()
    },
    getCurrentUser: function (options) {
      // decode the signed token
      var decoded = jwtDecode(localStorage.getItem(Config.tokenHandle))
      if (!decoded.userId) {
        console.warn('something went wrong while decoding the json-webtoken')
        return false
      }
      if (!currentUser) {
        currentUser = API.getUserEntity(decoded.userId, options)
      }
      return currentUser
    },
    logoutUser: function () {
      console.warn('temporarely disabled')
      localStorage.removeItem(Config.tokenHandle)
    }
  }

  App.globalChannel.reply({
    'user:entities': API.getUserEntities,
    'user:entity': API.getUserEntity,
    'user:entity:current': API.getCurrentUser
  })

  App.globalChannel.on('user:entity:logout', API.logoutUser)
  App.globalChannel.reply('user:entity:edit', function () {
    return API.newUserEntity()
  })

  App.globalChannel.reply('user:entity:new', function () {
    return API.newUserEntity()
  })

//
}

module.exports = Users



// WEBPACK FOOTER //
// ./js/entities/users.js